import { Link } from "react-router";
import type { PostSummary } from "@shared/contracts";
import { routes } from "../../app/routes";
import { formatDate } from "../../platform/time/format-date";
import { GlowPanel } from "../../platform/ui/GlowPanel";
import { useReaction } from "../avatar";

/**
 * One post in the list, on the plate from Orla's email signature. The whole plate is the
 * link: the anchor covers it, so there is one target and one focus ring, not two.
 */
export function PostCard({ post }: { post: PostSummary }) {
  const reaction = useReaction({ gesture: "Wave" });
  return (
    <GlowPanel variant="feature" interactive className="post-card">
      <article>
        <p className="post-card__meta">
          {post.publishedAt ? (
            <time dateTime={post.publishedAt}>{formatDate(post.publishedAt)}</time>
          ) : null}
        </p>
        <h2 className="post-card__title">
          <Link className="post-card__link" to={routes.post(post.slug)} {...reaction}>
            {post.title}
          </Link>
        </h2>
        <p className="post-card__summary">{post.summary}</p>
        <p className="post-card__more" aria-hidden="true">
          Read
          <span className="post-card__arrow">&rarr;</span>
        </p>
      </article>
    </GlowPanel>
  );
}
